<div class="domain-container container vh-100 d-flex flex-column justify-content-center align-items-center text-center">

    <div class="logo">
        <div></div>
    </div>

    <div class="w-100" style="max-width: 600px;">
        <h1 class="expired-title mb-3">{{'DomainExpired.Title' | translate}}</h1>

        <p class="fs-6 fw-semibold">
            {{'DomainExpired.P1' | translate}}
        </p>
        <p class="fs-6 fw-semibold">
            {{'DomainExpired.P2' | translate}}<br>
            {{'DomainExpired.P3' | translate}}
        </p>
    </div>
</div>